import Vue from 'vue'
import AutomatedDownload from './AutomatedDownload.vue'
import store from '@/store'
import config from '@/mixins/componentConfiguration'
import commonConfig from '@/mixins/commonMixin'
import moment from 'moment'

Vue.prototype.moment = moment

window.vm = new Vue({
  store,
  mixins: [commonConfig(Vue), config(Vue)],
  render: h => h(AutomatedDownload)
}).$mount('#downloadV2')
